import styled from 'styled-components';

export const LabelName = styled.div`
  font-size: 1.375rem;
`;
